<span class="clear-filters gtm-clear-filters selenium-clear-filters" (click)="clearFilters()">
    Clear Filters
    <app-icon class="icon" [type]="'Trash'"></app-icon>
</span>
